import styled from 'styled-components';
import toRem from 'utils/toRem';
import getTextColor from 'utils/getTextColor';
import { white } from 'constants/variables';
import getColor from './color_map';

const Container = ({
  backgroundColor,
  isFullWidth = true,
  hasReducedPadding,
  children,
  ...rest
}) => {
  const color = getColor(backgroundColor);

  return (
    <Wrapper
      color={isFullWidth ? color : undefined}
      textColor={getTextColor(color)}
      hasReducedPadding={hasReducedPadding}>
      <div className="v2-container">
        <Card color={!isFullWidth ? color : undefined} {...rest}>
          {children}
        </Card>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-block: ${({ hasReducedPadding }) =>
    toRem(hasReducedPadding ? 32 : 64)};
  background-color: ${({ color }) => color || 'transparent'};
  color: ${({ textColor }) => textColor};
`;

const Card = styled.div`
  background-color: ${({ color }) => color || 'transparent'};
  padding: ${({ color }) => (color && color !== white ? toRem(32) : 0)};
`;

export default Container;
